import { IUserAccount } from '../types';
import { HydraQueryParams, useHydraQuery } from './useHydraQuery';

export function useGetPermitHoldersQuery<D extends IUserAccount[]>(params?: HydraQueryParams<D>) {
  const { vars, options, key } = params || {};

  return useHydraQuery<D>(
    key ?? `getPermitHoldersQuery`,
    `/api/user_accounts?exists[type]=false&pagination=false&roles=ROLE_DETENTEUR_PERMIS`,
    {
      vars,
      options,
    }
  );
}
